import BaseQuery from "@/stateManagement/BaseQuery";
import RewardsEarnPointsStore, {
    EarnPointsState,
} from "@apps/rewards/modules/EarnPoints/store/RewardsEarnPointsStore";
import { filterNilValue } from "@datorama/akita";
import { injectable } from "tsyringe";

@injectable()
class RewardsEarnPointsQuery extends BaseQuery<EarnPointsState> {
    constructor(protected store: RewardsEarnPointsStore) {
        super(store);
    }

    amountForProduct$ = this.select(
        (state) => state.rewardsEarnPoints?.amountForProduct
    ).pipe(filterNilValue());

    status$ = this.select((state) => state.status);
}

export default RewardsEarnPointsQuery;
